import { Injectable } from '@angular/core';
import { LogLevel } from '../models';
import { LoggingPublishersService } from './logging-publisher.service';

@Injectable()
export class LoggingService {
	private defaultLogLevel: LogLevel = LogLevel.Error;
	private currentLogLevel: LogLevel;

	public constructor(private publishersService: LoggingPublishersService) {}

	public error(title: string, body: any): void {
		this.log(title, body, LogLevel.Error);
	}

	public warn(title: string, body: any): void {
		this.log(title, body, LogLevel.Warning);
	}

	public info(title: string, body: any): void {
		this.log(title, body, LogLevel.Info);
	}

	public setCurrentLevel(logLevel: LogLevel) {
		this.currentLogLevel = logLevel;
	}

	private shouldLog(level: LogLevel): boolean {
		if (this.currentLogLevel != null) {
			return level >= this.currentLogLevel;
		}
		return level >= this.defaultLogLevel;
	}

	private log(title: string, body: any, logLevel: LogLevel): void {
		if (this.shouldLog(logLevel)) {
			this.publishersService.getPublishers().forEach((publisher) => {
				publisher.log(title, JSON.stringify(body, Object.getOwnPropertyNames(body)), logLevel);
			});
		}
	}
}
